var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionMarkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,18.4c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2C14,19.4,13.1,18.4,12,18.4z M17.5,4.4c-1-1.6-2.8-2.8-5.6-2.8 c-2.5,0-4.4,1.2-5.5,2.9c-0.6,0.8-0.2,2,0.8,2.4v0c0.7,0.3,1.6,0.1,2-0.6c0.5-0.9,1.4-1.6,2.8-1.6c3,0,3.6,2.8,2.5,4.3 c-1,1.4-2.7,2.4-3.6,4c-0.3,0.6-0.5,1.3-0.5,1.9c-0.1,1,0.7,1.8,1.7,1.8h0.1c0.9,0,1.6-0.7,1.7-1.5c0.1-0.5,0.2-0.8,0.3-1.1 c0.7-1.3,2.1-2,3.5-4C18.8,8.3,18.4,5.7,17.5,4.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIcon);
export default __webpack_public_path__ + "static/media/QuestionMarkIcon.68e2dd52bd0cbfb7187b426e459a666b.svg";
export { ForwardRef as ReactComponent };